import axios from "axios";
import { myApi } from "../../../constants/consts";
import { installDateFix } from "../../../utils/dateUtils";

// ───────────────────────────────────────────────────────────
// Bu service için özel axios instance
// installDateFix, API'den gelen "Sun, 11 Oct 2026 23:43:22 GMT"
// biçimindeki tarihleri otomatik olarak "2026-10-11T23:43:22"
// (timezone'suz → yerel saat) biçimine çevirir.
// ───────────────────────────────────────────────────────────
const api = axios.create();
installDateFix(api);

export const customerService = {
  async getCompanyBySunucu(sunucu_kodu) {
    const res = await api.post(`${myApi}/get_all_company_by_sunucu`, {
      sunucu_kodu,
    });
    return res.data;
  },

  async getUserById(user_id) {
    const res = await api.get(`${myApi}/get_user_by_id`, {
      params: { user_id },
    });
    return res.data;
  },

  async updateUserData({
    id,
    username,
    phone,
    email,
    sunucu_kodu,
    pass,
    type,
  }) {
    const res = await api.post(`${myApi}/update_user_data`, {
      id,
      username,
      phone,
      email,
      sunucu_kodu,
      pass,
      type: type || "user",
    });
    return res.data;
  },

  /**
   * Sunucu koduna göre eğitim listesini getirir.
   * Flutter: GET $myApi/get_edu_by_sunucukodu/{sunucu_kodu}
   */
  async getEduBySunucuKodu(sunucu_kodu) {
    const res = await api.get(
      `${myApi}/get_edu_by_sunucukodu/${encodeURIComponent(sunucu_kodu)}`,
    );
    return res.data;
  },

  async getInformationBank() {
    // Flutter: GET $myApi/get_Information  (büyük I)
    const res = await api.get(`${myApi}/get_Information`);
    return res.data;
  },

  async getNotifications(sunucuKodu, userType) {
    const res = await api.post(`${myApi}/get_notification`, {
      sunucuKodu,
      userType,
    });
    return res.data;
  },

  /**
   * Kullanıcının destek taleplerini getirir.
   * user_type === "user" ise user_id ile, aksi halde sunucu_kodu ile.
   */
  async getSupportsByUser({ userType, userId, sunucuKodu }) {
    const url =
      userType === "user"
        ? `${myApi}/get_supports_by_user_id?user_id=${encodeURIComponent(userId)}`
        : `${myApi}/get_supports_by_sunucu_kodu?sunucu_kodu=${encodeURIComponent(
            sunucuKodu,
          )}`;
    const res = await api.get(url);
    return res.data;
  },

  /**
   * Yeni destek talebi oluşturur.
   */
  async createSupportTicket({
    userId,
    title,
    description,
    sunucuKodu,
    username,
  }) {
    const res = await api.post(`${myApi}/create_support`, {
      user_id: userId,
      title,
      status: "Gönderildi",
      sunucu_kodu: sunucuKodu,
      supporter: "Havuz",
    });

    const supportId = res.data?.support_id;
    const desc = (description || "").trim();

    if (desc && supportId) {
      try {
        await api.post(`${myApi}/add_message`, {
          support_id: supportId,
          sender_id: userId,
          receiver_id: null,
          message: desc,
          sender_name: username || "Kullanıcı",
          user_type: "user",
          type: "txt",
        });
      } catch (e) {
        // Açıklama kaydedilemese bile talep açılmış olur
        console.warn("Açıklama mesaj olarak kaydedilemedi:", e?.message);
      }
    }

    return res.data;
  },

  /**
   * Güncelleme var mı kontrolü (polling).
   */
  async checkDataIsUpdated({ target = "user", userId, root = "support" }) {
    const res = await api.post(`${myApi}/check_data_is_updated`, {
      target,
      user_id: Number(userId),
      root,
    });
    return res.data?.data === true;
  },

  /**
   * Güncelleme bayrağını değiştir.
   */
  async changeUpdateValue({ target, newValue, userId, root = "support" }) {
    const res = await api.post(`${myApi}/change_status_update_value`, {
      target,
      new_value: newValue,
      user_id: userId,
      root,
    });
    return res.data;
  },
};
